import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import { fieldsToGqlString } from '../../../util/shared/vue-global';
// import remitUnit from '../../shared/remitUnits';

const { backend } = clients.direct;

const fieldsOfWarrants = {
  axFromDate: '',
  axToDate: '',
  taxUnit: '',
  unitDesc: '',
  unitFund: '',
  source: '',
  sourceDesc: '',
  amount: '',
  glFund: '',
  warrant: '',
  warrantDate: '',
  remitUnit: '',
  warrantsCreated: '',
  isLocked: '',
};

export const apportionmentRemitWarrants = {
  namespaced: true,
  state: () => ({
    selectedItems: [],
  }),
  mutations: {
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
  },
  actions: {
    async loadApportionmentRemitWarrantsRecords({ commit, dispatch }, { criteria, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query apportionmentWarrants($criteria: apportionmentWarrantsCriteriaType) {
            apportionmentWarrants(criteria: $criteria) {
                    ${fieldsToGqlString(fieldsOfWarrants)},
                    }
                  }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);

        if (results.data) {
          const apportionmentWarrantsData = results.data.apportionmentWarrants;
          commit('base/crud/setItems', [baseCrudKey, apportionmentWarrantsData], { root: true });
          return apportionmentWarrantsData;
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting records', { root: true });
      }
      return [];
    },
    async remitWarrantsBuildRecords({ commit, dispatch }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql` mutation
          buildRemitWarrantsRecords ($criteria: apportionmentWarrantsCriteriaType) {
            buildRemitWarrantsRecords(criteria: $criteria) {
              status
            },
          }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const result = results.data ? (results.data.buildRemitWarrantsRecords || {}) : {};
        dispatch('flashSuccess', 'build records done Successfully', { root: true });
        return result;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There is a problem while building records.', { root: true });
      }
      return null;
    },
    async buildActualWarrantsRecord({ commit, dispatch }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql` mutation
          buildWarrantsRecord ($criteria: apportionmentWarrantsCriteriaType) {
            buildWarrantsRecord(criteria: $criteria) {
              status
            },
          }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const result = results.data ? (results.data.buildWarrantsRecord || {}) : {};
        dispatch('flashSuccess', 'build records done Successfully', { root: true });
        return result;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        // Surface the backend's own message - a second Import Warrants for the same date
        // while one is running is refused with a specific reason.
        const gqlMessage = (e.graphQLErrors && e.graphQLErrors[0] && e.graphQLErrors[0].message)
          || e.message;
        dispatch('flashError', gqlMessage || 'There is a problem while building records.', { root: true });
      }
      return null;
    },
  },
};

export default apportionmentRemitWarrants;
